import Message from "../../message";
import {useMainStore} from "@/store";

export default class MemberOffline extends Message
{
    handle()
    {
        useMainStore().SET_GUILD_MEMBER_OFFLINE(this.message.id);
    }
}
